import script from "./ShopMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ShopMenu.vue?vue&type=style&index=0&id=5ec1c5ac&lang=scss"

const __exports__ = script;

export default __exports__